const breadCrumb = "Lançamento de Notas - Relatório de Notas";

const routes = [
  {
    path: "/emitir-declaracao-notas",
    name: "emitir-declaracao-notas",
    meta: {
      allowedPermissions: ["aluno_avaliacao_nota_emitir_declaracao_notas"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/EmitirDeclaracaoNotas/EmitirDeclaracaoNotas.vue"),
  },
];

export default routes;
